
import { useQuery } from "@tanstack/react-query"
import { getCustomer_Data_Report } from "./Customer_DataReport_Repo"

export const UseCustomer_Data_Report=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['CUSTOMER_DATA_REPORT',param],
        queryFn:()=>getCustomer_Data_Report(param),
        enabled:enable,
        retry:false,
    })
}